import React, { ButtonHTMLAttributes, forwardRef } from "react";
import type { IconComponent } from "../../types/ui";
type Variant = 'primary' | 'secondary' | 'ghost' | 'navy' | 'danger' | 'glass';
type Size = 'sm' | 'md';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  icon?: IconComponent;
  iconRight?: IconComponent;
}
const VARIANTS: Record<Variant, string> = {
  primary: 'bg-flame text-white shadow-sm shadow-flame/30 hover:bg-flame-dark focus-visible:ring-flame/40',
  secondary: 'bg-white text-navy ring-1 ring-inset ring-slate-200 hover:bg-slate-50 hover:ring-slate-300 focus-visible:ring-azure/40',
  ghost: 'text-azure hover:bg-azure/10 focus-visible:ring-azure/40',
  navy: 'bg-navy text-white hover:bg-navy-light focus-visible:ring-navy/40',
  danger: 'bg-white text-rose-600 ring-1 ring-inset ring-rose-200 hover:bg-rose-50 focus-visible:ring-rose-300',
  glass: 'bg-white/10 text-white ring-1 ring-inset ring-white/20 hover:bg-white/20 focus-visible:ring-white/40'
};
const SIZES: Record<Size, string> = {
  sm: 'h-8 gap-1.5 rounded-lg px-3 text-xs',
  md: 'h-10 gap-2 rounded-xl px-4 text-sm'
};
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button({
  variant = 'secondary',
  size = 'md',
  icon: Icon,
  iconRight: IconRight,
  className = '',
  children,
  type = 'button',
  ...rest
}, ref) {
  return <button ref={ref} type={type} className={`inline-flex shrink-0 items-center justify-center font-medium transition-colors focus:outline-none focus-visible:ring-4 disabled:cursor-not-allowed disabled:opacity-50 ${VARIANTS[variant]} ${SIZES[size]} ${className}`} {...rest} data-id="element-742" data-mp="12nbub662cssd">
      {Icon && <Icon className={size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4'} aria-hidden="true" data-id="element-743" data-mp="17ebow4rpmyrp" />}
      {children}
      {IconRight && <IconRight className={size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4'} aria-hidden="true" data-id="element-744" data-mp="1ldl4b283doum" />}
    </button>;
});